import React from 'react';
import { Link } from 'react-router-dom';
import logoCoatArms from '../assets/logo-coat-arms.png';
import support from '../../../../assets/img/utils/support.png';

const AnnouncementHeader: React.FC = () => (
  <div className="sa-header">
    <div className="sa-header__inner">
      <Link to="/" className="sa-header__brand" aria-label="Ana səhifə">
        <img src={logoCoatArms} alt="" className="sa-header__brand-arms" />
        <p className="sa-header__brand-name">
          Azərbaycan Respublikasının
          <br />
          Mənzil İnşaatı Dövlət Agentliyi
        </p>
      </Link>
      <img src={support} width={50} height={50} alt="" />
    </div>
  </div>
);

export default AnnouncementHeader;